module.exports = __webpack_public_path__ + "img/b1.aba98498.png";